<template>
  <div class="page-body">
    <UsersFilter
      v-if="this.$route.params.type !== 'inprogress-cards'"
      @onFilterUsers="handleFilter"
    />
    <b-card class="content-card">
      <div fluid>
        <b-skeleton-table
          v-if="loading"
          :rows="5"
          :columns="5"
          :table-props="{ bordered: true, striped: true }"
        >
        </b-skeleton-table>
        <b-table
          v-if="!loading"
          :items="users"
          :fields="fields"
          empty-text="موردی یافت نشد"
          stacked="md"
          show-empty
          small
        >
          <template #cell(number)="row">
            <div class="text-right">
              {{
                row.item.cellPhone.number != null
                  ? row.item.cellPhone.number
                  : "---"
              }}
            </div>
          </template>
          <template #cell(name)="row">
            <div class="text-right">
              {{ row.item.firstName != null ? row.item.firstName : "---" }}
              {{ row.item.lastName != null ? row.item.lastName : "---" }}
            </div>
          </template>

          <template #cell(role)="row">
            <div class="text-right">
              <b-badge v-if="row.item.role != 'UserLevel0'" variant="success">
                {{ getLevelName(row.item.role) }}
              </b-badge>
              <b-badge v-if="row.item.role == 'UserLevel0'" variant="danger">
                {{ getLevelName(row.item.role) }}
              </b-badge>
            </div>
          </template>

          <template #cell(email)="row">
            <div class="userEmailWrapper">{{ row.item.email }}</div>
          </template>

          <template #cell(actions)="row">
            <b-button
              size="sm"
              :to="`/user-profile/${row.item.id}`"
              variant="primary"
              class="mr-1"
            >
              نمایش پروفایل کاربر
            </b-button>
          </template>
        </b-table>
        <br/>
        <b-row no-gutters>
          <b-col sm="12" class="my-1 d-flex justify-content-center">
            <BasePagination
              :showNext="showNext"
              :showPrev="currentPage !== 0"
              @onClick="handlePaginationClick"
            />
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import http from "@/httpservices/HttpService"
import BasePagination from "@/components/BasePagination.vue";
import UsersFilter from "@/components/UsersFilter.vue";
import store from '@/store'


export default {
  components: {BasePagination, UsersFilter},

  data() {
    return {
      loading: false,
      currentPage: 0,
      filterData: {
        role: "",
        uncompletedStep: "",
        cardNumber: "",
        infoQuery: "",
        IBan: "",
        perPage: 25,
      },

      users: [],
      fields: [
        {
          key: "number",
          label: "شماره",
          sortable: true,
          class: "text-right",
        },
        {
          key: "name",
          label: "نام",
          sortable: true,
          class: "text-right",
        },
        {
          key: "nationalCode",
          label: "کد ملی",
          sortable: true,
          class: "text-right",
        },
        {
          key: "email",
          label: "ایمیل",
          sortable: true,
          class: "text-right",
        },
        {key: "actions", label: "عملیات"},
      ],
    };
  },

  watch: {
    $route: function () {
      this.currentPage = 0;
      if (this.$route.params.type === "document") {
        this.filterData.uncompletedStep = "Documents";
      } else if (this.$route.params.type === "personal-info") {
        this.filterData.uncompletedStep = "PersonalInfo";
      } else if (this.$route.params.type === "addresses") {
        this.filterData.uncompletedStep = "AddressPostalCode";
      } else {
        this.filterData.uncompletedStep = "";
      }
      this.getUsers();
    },
  },

  computed: {
    showNext() {
      if (this.currentPage === 0) {
        if (this.users.length < this.filterData.perPage) {
          return false;
        } else {
          return true;
        }
      } else {
        if (
          this.users.length < this.filterData.perPage ||
          this.users.length === 0
        ) {
          return false;
        } else {
          return true;
        }
      }
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return {text: f.label, value: f.key};
        });
    },
    isSuperAdmin() {
      return store.getters['isSuperAdmin']
    },
  },

  created() {
    if ("undefined" !== typeof this.$route.params.page) {
      this.page = parseInt(this.$route.params.page);
    }
  },

  mounted() {
    // Set the initial number of items
    if ("undefined" !== typeof this.$route.params.page) {
      this.page = parseInt(this.$route.params.page);
    }

    if (this.$route.params.type === "document") {
      this.filterData.uncompletedStep = "Documents";
    } else if (this.$route.params.type === "personal-info") {
      this.filterData.uncompletedStep = "PersonalInfo";
    } else if (this.$route.params.type === "addresses") {
      this.filterData.uncompletedStep = "AddressPostalCode";
    } else {
      this.filterData.uncompletedStep = "";
    }

    this.$nextTick(() => {
      this.getUsers();
    });
  },

  methods: {
    handleFilter(data) {
      this.currentPage = 0;
      this.filterData.role = data.role;
      this.filterData.uncompletedStep = data.uncompletedStep;
      this.filterData.cardNumber = data.cardNumber;
      this.filterData.infoQuery = data.infoQuery;
      this.filterData.IBan = data.IBan;
      this.filterData.perPage = data.perPage;

      this.getUsers();
    },

    handlePaginationClick(value) {
      if (value === -1) {
        if (this.currentPage > 0) {
          this.currentPage--;
          this.getUsers();
        }
      } else if (value === 1) {
        this.currentPage++;
        this.getUsers();
      }
    },

    async getUsers() {
      this.loading = true;
      const token = localStorage.getItem("token") || "";

      if (this.isSuperAdmin) {
        http.get(`/Accounts/qt/${this.filterData.perPage}/page/${this.currentPage}`, {
          params: {
            Role: this.filterData.role,
            CardNumber: this.filterData.cardNumber,
            Iban: this.filterData.IBan,
            InfoQuery: this.filterData.infoQuery,
            UncompletedStep: this.filterData.uncompletedStep,
          }
        })
          .then((response) => {
            this.users = [];
            this.users = response.data;
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
            //console.log(err);
            //this.$router.push("/500");
          });
      } else {
        console.log({isSuperAdmin: 'limited'})
        try {
          this.users = [];
          const res = await http.get(`/Accounts/limited-search/${this.filterData.perPage}/page/${this.currentPage}`, {
            params: {
              Role: this.filterData.role,
              CardNumber: this.filterData.cardNumber,
              Iban: this.filterData.IBan,
              InfoQuery: this.filterData.infoQuery,
              UncompletedStep: this.filterData.uncompletedStep,
            }
          })
          this.users = res.data;

        } catch (e) {
          console.log(e)
        }

        this.loading = false;
      }
    },

    editUser() {
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .userEmailWrapper {
    padding-top: 28px;
  }
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group
> .input-group-prepend:first-child
> .input-group-text:not(:first-child) {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation)
> .custom-file:not(:last-child)
.custom-file-label::after {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.input-group .form-control:not(:last-child) {
  border-left: 0 !important;
  padding-left: 0 !important;
  border-right: 1px solid rgb(202, 209, 215);
  padding-right: 16px !important;
}
</style>
